

import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { MwcSafeAny } from 'mwc/core/types';

import { MwcMenuModeType, MwcMenuThemeType } from './menu.types';

@Injectable()
export class MenuService {
  /** all descendant menu click **/
  descendantMenuItemClick$ = new Subject<MwcSafeAny>();
  /** child menu item click **/
  childMenuItemClick$ = new Subject<MwcSafeAny>();
  theme$ = new BehaviorSubject<MwcMenuThemeType>('light');
  mode$ = new BehaviorSubject<MwcMenuModeType>('vertical');
  inlineIndent$ = new BehaviorSubject<number>(24);
  isChildSubMenuOpen$ = new BehaviorSubject<boolean>(false);

  onDescendantMenuItemClick(menu: MwcSafeAny): void {
    this.descendantMenuItemClick$.next(menu);
  }

  onChildMenuItemClick(menu: MwcSafeAny): void {
    this.childMenuItemClick$.next(menu);
  }

  setMode(mode: MwcMenuModeType): void {
    this.mode$.next(mode);
  }

  setTheme(theme: MwcMenuThemeType): void {
    this.theme$.next(theme);
  }

  setInlineIndent(indent: number): void {
    this.inlineIndent$.next(indent);
  }
}
